/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { ProfileAddress } from './profile-address.model';


export class Organisation {
    id: string; //id
    kbo?: string; // ecf001
    establishmentNumber: string; //VestigingsPlaatsNummer
    officeName?: string; // ecf001
    officeStatus?: string; // ecf001
    legalForm?: string; // ecf001
    address?: ProfileAddress; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Organisation {
        if (!data) { return instance; }
        if (data.id != null) {instance.id = data.id; } 
        if (data.kbo != null) {instance.kbo = data.kbo; }
        if (data.establishmentNumber != null) {instance.establishmentNumber = data.establishmentNumber; }
        if (data.officeName != null) {instance.officeName = data.officeName; }
        if (data.officeStatus != null) {instance.officeStatus = data.officeStatus; }
        if (data.legalForm != null) {instance.legalForm = data.legalForm; }
        if (data.address != null) {instance.address = new ProfileAddress().fromJSON(data.address); } // i8
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Organisation.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Organisation) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Organisation.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Organisation): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
